import React from 'react';
import DanFeeList from '../components/fees/DanFeeList';
import LicenseFeeList from '../components/fees/LicenseFeeList';
import AnnualFeeList from '../components/fees/AnnualFeeList';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

export default function FeesPage() {
    return (
        <div className="p-4">
            <div className="text-3xl text-800 font-bold mb-4">Taxas</div>
            <DanFeeList />
            <LicenseFeeList />
            <AnnualFeeList />
        </div>
    );
}
